import React, { useEffect } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data'
import View from './view.js'

export default function Logic(props) {
  let content = useDataValue({
    context: 'sms-content',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    change(next => {
      next.data.sms_template = {
        ...next.data.sms_template,
        content: content,
        original_content: content,
        enabled: true,
      }
    })
  }, [])

  return <View {...props} />
}
